import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import ActivitySubmenuContent from './ActivitySubmenu';
const ActivitySubmenuLogic: FC = () => {
  const router = useRouter();
  const [activePath, setActivePath] = useState<string>('');
  const {
    setIsNewsOpen
  } = headerStore(state => state);
  const path = router.pathname.split('/')[1];
  useEffect(() => {
    setActivePath(path);
  }, [router]);
  return <ActivitySubmenuContent setIsOpen={setIsNewsOpen} activePath={activePath} />;
};
export default ActivitySubmenuLogic;